import React from 'react';

const ManualInputForm = ({ 
  newLocation, 
  error, 
  handleInputChange, 
  handleAddManualLocation 
}) => {
  return (
    <div className="manual-input-section">
      <h4>Manually Input Location Points</h4>
      {error && <div className="error-message">{error}</div>}
      <form className="manual-form" onSubmit={handleAddManualLocation}>
        <input 
          type="text" 
          name="latitude"
          value={newLocation.latitude}
          onChange={handleInputChange}
          placeholder="Latitude (-90 ~ 90)" 
          className="manual-input" 
        />
        <input 
          type="text" 
          name="longitude"
          value={newLocation.longitude}
          onChange={handleInputChange}
          placeholder="Longitude (-180 ~ 180)" 
          className="manual-input" 
        />
        <button type="submit" className="manual-add-btn">Add</button>
      </form>
    </div>
  );
};

export default ManualInputForm; 